import { ReactNode, useCallback, useState } from 'react'

import PlainConfirmModal from 'app/common/ui-next/plain-confirm-modal'


type Props = {
  children: (toggle: () => void) => ReactNode
  confirmButtonTitle: string
  cancelButtonTitle: string
  messageText: string
  onConfirm: () => void
}

const RefillConfirm = ({
  children,
  confirmButtonTitle,
  cancelButtonTitle,
  messageText,
  onConfirm,
}: Props) => {
  const [displayConfirm, setDisplayConfirm] = useState(false)
  const toggleConfirm = useCallback(() => setDisplayConfirm(p => !p), [])
  const handleConfirm = useCallback(() => {
    setDisplayConfirm(false)
    onConfirm()
  }, [onConfirm])

  return (
    <>
      {children(toggleConfirm)}
      {displayConfirm
        && <PlainConfirmModal
          confirmButtonTitle={confirmButtonTitle}
          cancelButtonTitle={cancelButtonTitle}
          messageText={messageText}
          onCancel={toggleConfirm}
          onConfirm={handleConfirm}
        />}
    </>
  )
}

export default RefillConfirm
